module.exports = __webpack_public_path__ + "img/fangan02.296213c8.jpeg";